import { c as _c } from "react/compiler-runtime";
import React from "react";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { cicToType } from "@/helpers/Helpers";
import Link from "next/link";
import UserCICAndLevel, { UserCICAndLevelSize } from "@/components/user/utils/UserCICAndLevel";
import WinnerDropBadge from "@/components/waves/drops/winner/WinnerDropBadge";
import WaveDropTime from "@/components/waves/drops/time/WaveDropTime";
import UserProfileTooltipWrapper from "@/components/utils/tooltip/UserProfileTooltipWrapper";
interface WaveLeaderboardDropAuthorProps {
  readonly drop: ExtendedDrop;
}
export const WaveLeaderboardDropAuthor: React.FC<WaveLeaderboardDropAuthorProps> = t0 => {
  const $ = _c(34);
  const {
    drop
  } = t0;
  const t1 = `/${drop.author.handle}`;
  let t2;
  if ($[0] !== drop.author.pfp) {
    t2 = <div className="tw-h-11 tw-w-11 tw-bg-iron-900 tw-relative tw-flex-shrink-0 tw-rounded-lg">{drop.author.pfp ? <div className="tw-rounded-lg tw-h-full tw-w-full"><div className="tw-h-full tw-w-full tw-max-w-full tw-rounded-lg tw-overflow-hidden tw-bg-iron-900 tw-ring-1 tw-ring-white/10"><div className="tw-h-full tw-text-center tw-flex tw-items-center tw-justify-center tw-rounded-lg tw-overflow-hidden"><img src={drop.author.pfp} alt="Profile picture" className="tw-bg-transparent tw-max-w-full tw-max-h-full tw-h-auto tw-w-auto tw-mx-auto tw-object-contain" /></div></div></div> : <div className="tw-h-full tw-w-full tw-bg-iron-900 tw-ring-1 tw-ring-inset tw-ring-white/10 tw-rounded-lg" />}</div>;
    $[0] = drop.author.pfp;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = <Link href={t1} onClick={_temp} className="tw-flex tw-items-center tw-gap-x-2 tw-no-underline group">{t2}</Link>;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = drop.author.level;
  let t5;
  if ($[5] !== drop.author.cic) {
    t5 = cicToType(drop.author.cic);
    $[5] = drop.author.cic;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== drop.author.level || $[8] !== t5) {
    t6 = <UserCICAndLevel level={t4} cicType={t5} size={UserCICAndLevelSize.SMALL} />;
    $[7] = drop.author.level;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = drop.author.handle ?? drop.author.id;
  const t8 = `/${drop.author.handle}`;
  let t9;
  if ($[10] !== drop.author.handle) {
    t9 = <span className="tw-text-md tw-mb-0 tw-leading-none tw-font-semibold">{drop.author.handle}</span>;
    $[10] = drop.author.handle;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t8 || $[13] !== t9) {
    t10 = <Link href={t8} onClick={_temp2} className="tw-no-underline">{t9}</Link>;
    $[12] = t8;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10 || $[16] !== t7) {
    t11 = <UserProfileTooltipWrapper user={t7}>{t10}</UserProfileTooltipWrapper>;
    $[15] = t10;
    $[16] = t7;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="tw-size-[3px] tw-bg-iron-900 tw-rounded-full tw-flex-shrink-0" />;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== drop.created_at) {
    t13 = <WaveDropTime timestamp={drop.created_at} />;
    $[19] = drop.created_at;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== t11 || $[22] !== t13 || $[23] !== t6) {
    t14 = <div className="tw-flex tw-items-center tw-gap-x-2">{t6}{t11}{t12}{t13}</div>;
    $[21] = t11;
    $[22] = t13;
    $[23] = t6;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  const t15 = drop.winning_context?.decision_time || null;
  let t16;
  if ($[25] !== drop.rank || $[26] !== t15) {
    t16 = <div className="tw-flex tw-items-center tw-gap-x-2"><WinnerDropBadge rank={drop.rank} decisionTime={t15} /></div>;
    $[25] = drop.rank;
    $[26] = t15;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== t14 || $[29] !== t16) {
    t17 = <div className="tw-flex tw-flex-col tw-gap-y-1.5">{t14}{t16}</div>;
    $[28] = t14;
    $[29] = t16;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== t17 || $[32] !== t3) {
    t18 = <div className="tw-flex tw-items-center tw-gap-x-3">{t3}{t17}</div>;
    $[31] = t17;
    $[32] = t3;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  return t18;
};
function _temp(e) {
  return e.stopPropagation();
}
function _temp2(e_0) {
  return e_0.stopPropagation();
}